import axios from 'axios';
import html2canvas from 'html2canvas';
import { getOdrBaseUrl, getAzureRecordingBaseUrl } from '../socket';
var CryptoJS = require("crypto-js");
// let baseUrl='http://192.168.2.61:6061/'
let recordingId = ''
export const takeScreenShot = async ({ uinfo, ToCaptureRef, tokenFromAzureLogin, toast, openAndRefreshList }) => {
  toast.error('Captured Screenshot')
  if (ToCaptureRef.current) {
    html2canvas(ToCaptureRef.current, {
      useCORS: true,
    })
      .then((canvas) => {
        console.log("canvas " + canvas);
        const imageBase64 = canvas.toDataURL('image/png');
        console.log("base64 of screenshot imageBase64: " + imageBase64);
        uploadBase64(uinfo, imageBase64, tokenFromAzureLogin, toast, openAndRefreshList);
      })
      .catch((error) => {
        console.error("An error occurred while capturing the canvas:", error);
      });
  } else {
    console.error("ToCaptureRef.current is not set or invalid.");
  }
};

const uploadBase64 = async (uinfo, imageBase64, tokenFromAzureLogin, toast, openAndRefreshList) => {
  if (imageBase64 && imageBase64.includes('base64,')) {
    imageBase64 = imageBase64.split('base64,')[1]
  }

  const url = getOdrBaseUrl() + "api/CaseMgmt/CM_Efiling_Hearing_Files_Ins"; // replace with your API endpoint
  const headers = {
    "Content-Type": "application/json", // specify the content type
    "Authorization": `Bearer ${tokenFromAzureLogin}`,
  };
  const date = new Date();
  const formattedDate = date.toISOString().replace('T', ' ').slice(0, -1);
  const body = {
    "requestdata": uinfo + '|' + formattedDate, //"27|A|1|Rajeev|0|L|Tue Sep 16 2024 12:02:24 GMT+0530 (India Standard Time)"
    "filetype": "I",
    "encdata_base64": imageBase64
  };
  console.log("--img upload--headers--", headers);
  try {
    const response = await axios.post(url, body, { headers });
    console.log("--img-upload-response--", response)
    toast.success('Screenshot uploaded')
    openAndRefreshList()
  } catch (error) {
    console.error("Error making POST request:", error);
  }
}

//get screenshot list
export const getScreenshotList = async ({ progressId, tokenFromAzureLogin }) => {
  const url = getOdrBaseUrl() + "api/CaseMgmt/CM_Efiling_Hearing_Files_List"; // replace with your API endpoint
  const headers = {
    "Content-Type": "application/json", // specify the content type
    "Authorization": `Bearer ${tokenFromAzureLogin}`,
  };
  let encryptedProgressId = getEncryptedValue(progressId)
  console.log('---progressId-list---', progressId, tokenFromAzureLogin)
  const body = {
    "fk_efileprogressId": encryptedProgressId,
    "pageIndex": 1,
    "pageSize": 10
  };
  console.log("---screenshot list req-- " + JSON.stringify(body));
  try {
    const response = await axios.post(url, body, { headers });
    console.log("---screenshot list res-- ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error making POST request:", error);
  }
}

//get screenshot base64 using its name
export const getScreenshotImge = async ({ tokenFromAzureLoginBackUp, item }) => {
  const url = getOdrBaseUrl() + "api/Home/ODR_CommonDocument_Download"; // replace with your API endpoint
  const headers = {
    "Content-Type": "application/json", // specify the content type
    "Authorization": `Bearer ${tokenFromAzureLoginBackUp}`,
  };
  //let encryptedProgressId=getEncryptedValue(progressId)
  const body = {
    "FolderName": item.docPath,// "EfilingCaseProgressDocPath"
    "FileName": item.filename_gen, //"Hearingdoc_638620991870755906.png"
    "Id": item.fk_efilingId,  //(fk_efilingId encrypted value)
    "Id2": "ejdNQlJacUZDdlpuWm5zTFh4RjFIQT09Ojl1eVdINVk2a1NIbXBldDU="  /// (0 encrypted Value)
  };
  console.log("body - get screenshot api call req " + JSON.stringify(body));
  try {
    const response = await axios.post(url, body, { headers });
    console.log("1--- " + response);
    console.log("get screenshot base64 api call res:--- " + response.data.documentencdata);
    //localStorage.setItem('base64', response.data.documentencdata);
    return response.data;
  } catch (error) {
    console.error("Error making POST request:", error);
  }
}

export const getServerCallId = async (callId, tokenFromAzureLogin) => {
  const url = getOdrBaseUrl() + "api/CaseMgmt/CM_VideoDtls_OnCallId_Get"; // replace with your API endpoint
  //let getToken = localStorage.getItem('tokenData');
  const headers = {
    "Content-Type": "application/json", // specify the content type
    "Authorization": `Bearer ${tokenFromAzureLogin}`,
  };
  const body = {
    "Callid": callId,
  };
  console.log(callId, "--server callid req-- " + tokenFromAzureLogin);
  try {
    const response = await axios.post(url, body, { headers });
    console.log("--server callid res: --  ", response);
    let serverCallId = response?.data?.serverCallId
    return {
      serverCallId: serverCallId
    };
  } catch (error) {
    console.error("Error making POST request:", error);
  }
};

export const startRecording = async (serverCallId, callId, progressId, language) => {
  console.log(callId, "--recording api-- " + serverCallId);
  const url = getAzureRecordingBaseUrl() + "api/V1/ODRStartVideoRecordingFromUI"; // replace with your API endpoint
  const headers = {
    "Content-Type": "application/json", // specify the content type
  };
  const body = {
    "UserGuid": null,
    "CompanyGuid": null,
    "Version": "V1",
    "Data": {
      "Requestdata": progressId,
      "CorrelationIdFolder": callId,
      "ServerCallId": serverCallId,
      "SourceLanguage": language
    }
  };
  try {
    console.log("start recording req-" + url, JSON.stringify(body))
    //console.log("start recording 2-" + JSON.stringify(headers))
    const response = await axios.post(url, body, { headers: headers });
    console.log("start recording res:--" + JSON.stringify(response))
    //if (response?.data?.data?.recordingId) {
    recordingId = response?.data?.data?.recordingId;
    return {
      recordingId: recordingId
    };
  } catch (error) {
    console.error("Error making POST request:", error);
  }
};

export const pauseRecording = async () => {
  console.log("--pause recording api-- " + recordingId);
  const url = getAzureRecordingBaseUrl() + "api/V1/ODRPauseVideoRecordingFromUI"; // replace with your API endpoint
  const headers = {
    "Content-Type": "application/json", // specify the content type
  };
  const body = {
    "UserGuid": null,
    "CompanyGuid": null,
    "Version": "V1",
    "Data": {
      "RecordingId": recordingId
    }
  };
  try {
    console.log("pause recording req-" + url, JSON.stringify(body))
    const response = await axios.post(url, body, { headers: headers });
    console.log("pause res:--" + JSON.stringify(response))
    return {
      recordingId: response?.data?.data?.recordingId
    };
  } catch (error) {
    console.error("Error making POST request:", error);
  }
};

export const ResumeRecording = async () => {
  console.log("-resume-recording api-- " + recordingId);
  const url = getAzureRecordingBaseUrl() + "api/V1/ODRResumeVideoRecordingFromUI"; // replace with your API endpoint
  const headers = {
    "Content-Type": "application/json", // specify the content type
  };
  const body = {
    "UserGuid": null,
    "CompanyGuid": null,
    "Version": "V1",
    "Data": {
      "RecordingId": recordingId
    }
  };
  try {
    console.log("resume recording req-" + url, JSON.stringify(body))
    const response = await axios.post(url, body, { headers: headers });
    console.log("resume recording res:--", response)
    return {
      recordingId: response?.data?.data?.recordingId
    };
  } catch (error) {
    console.error("Error making POST request:", error);
  }
};
export const stopRecording = async () => {
  console.log("--stop recording -- " + recordingId);
  const url = getAzureRecordingBaseUrl() + "api/V1/ODRStopVideoRecordingFromUI"; // replace with your API endpoint
  const headers = {
    "Content-Type": "application/json", // specify the content type
  };
  const body = {
    "UserGuid": null,
    "CompanyGuid": null,
    "Version": "V1",
    "Data": {
      "RecordingId": recordingId
    }
  };
  try {
    console.log("stop recording req-" + url, JSON.stringify(body))
    const response = await axios.post(url, body, { headers: headers });
    console.log("recording stop res:--" + JSON.stringify(response))
    if (response?.data?.data?.recordingId) {
      return {
        recordingId: recordingId
      };
    }
  } catch (error) {
    console.error("Error making POST request:", error);
  }
};
export const startAndJoinCallApi = async (tokenFromAzureLogin, uInfo) => {
  const url = getOdrBaseUrl() + "api/CaseMgmt/CM_Efiling_Hearing_UserLog_InsUpd"; // replace with your API endpoint
  const headers = {
    "Content-Type": "application/json", // specify the content type
    "Authorization": `Bearer ${tokenFromAzureLogin}`,
  };
  const date = new Date();
  const formattedDate = date.toISOString().replace('T', ' ').slice(0, -1);
  const body = {
    "requestdata": uInfo + formattedDate
  };
  console.log(tokenFromAzureLogin, '-----join or start call req-------', body)
  try {
    const response = await axios.post(url, body, { headers: headers });

    console.log('---join or start call res--------', response)
  } catch (error) {
    console.error("Error making POST request:", error);
  }
};
export const listOfAllParticipant = async (tokenFromAzureLogin, progressId) => {
  console.log("-list of all parti1-- ", tokenFromAzureLogin, progressId);
  const url = getOdrBaseUrl() + "api/CaseMgmt/CM_Efiling_Hearing_AllAttendees_Get"; // replace with your API endpoint
  const headers = {
    "Content-Type": "application/json", // specify the content type
    "Authorization": `Bearer ${tokenFromAzureLogin}`,
  };
  const body = {
    "fk_efileprogressId": progressId
  };
  try {
    console.log("list of all parti req-" + url, JSON.stringify(body))
    const response = await axios.post(url, body, { headers: headers });
    console.log("list of all parti res:--" + JSON.stringify(response))
    let data = response?.data?._lstData;
    return data;
  } catch (error) {
    console.error("Error making POST request:", error);
  }
};

export const fetchRecordingId = () => {
  return recordingId;
}

export const setRecordingId = (id) => {
  recordingId = id;
  console.log("setRecordingId called with id: ", id);
}

const getEncryptedValue = (progressId) => {
  let key = "0123456789123456";
  var iv = getRandomString(16);
  let ciphertext = encrypt(iv, key, progressId);
  let ciphertextConversion = (ciphertext + ":" + iv);
  let encyrptedValue = btoa(ciphertextConversion);
  return encyrptedValue;
}

const getRandomString = () => {
  var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var result = '';
  for (var i = 0; i < 16; i++) {
    result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
  }
  return result;
}

const encrypt = (iv, passPhrase, plainText) => {
  var encrypted = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(plainText),
    CryptoJS.enc.Utf8.parse(passPhrase),
    { iv: CryptoJS.enc.Utf8.parse(iv), keySize: 128 / 8, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
  return encrypted;
}
